import axios from 'axios'
import dayjs from 'dayjs'

export default class ArticleService {

    getArticlesJson() {
        return axios.get(`/articles.json?cb=${new Date().getTime()}`);
    }

    async getRecentArticles(page, numberOfResults) {
        var articles = await this.getArticlesJson()
        articles.data = articles.data.filter(x => dayjs(x.publishDate) < Date.now())
        return articles.data.sort((a, b) => dayjs(b.publishDate) - dayjs(a.publishDate)).slice((page - 1) * numberOfResults, ((page - 1) * numberOfResults) + numberOfResults);
        // https://flaviocopes.com/how-to-sort-array-by-date-javascript/
    }

    async getArticleDetails(url) {
        var articleDetails = await this.getArticlesJson();
        return articleDetails.data.find(x => x.url === url);
    }

    async getArticleContent(url) {
        var response = await axios.get(`/article-contents/${url}.md`);
        return response.data;
    }

}